import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    platform = 'PC',
    username = '',
    password = '',
    verifyCode = '',
    verCodeId = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.user.login, {
        platform,
        username,
        password,
        verifyCode,
        verCodeId,
    }, options);
    if (error) return { error, status };
    return content || {};
};

